import { AbstractRenderer, Alignment, CellPanel, RowPanel, StaticParagraphComponent } from '@blk/simba';
import { CommonDCR } from '@ddt-web/config';

import { HeadingComponent, HeadingLevel } from './heading-component';

export class HeadingWithDateComponent {
	public buildHeader(name: string, headingDcr: string, heading: string, asOfDate: string, overrideLabelKey?: string, reducedSpacing?: boolean, level: HeadingLevel = HeadingLevel.H2): AbstractRenderer<SVGGElement> {
		const headingProportion = asOfDate ? 80 : 100;
		const panels = [
			new CellPanel(
				[
					new HeadingComponent(headingDcr, heading, level, reducedSpacing ? { paddingBottom: 0, paddingTop: 0 } : {})
				],
				{ proportion: headingProportion },
				Alignment.Horizontal.Left
			)
		];
		if (asOfDate) {
			panels.push(new CellPanel(
				[
					overrideLabelKey ? new StaticParagraphComponent(overrideLabelKey, CommonDCR[overrideLabelKey], { 0: asOfDate },
						{ paddingBottom: reducedSpacing ? 0 : 8 })
						: new StaticParagraphComponent('AS_OF', 'As of {0}', { 0: asOfDate }, { paddingBottom: reducedSpacing ? 0 : 8 })
				],
				{ useFullHeight: true, proportion: 100 - headingProportion },
				Alignment.Horizontal.Right,
				null,
				Alignment.Vertical.Bottom
			));
		}
		return new RowPanel(name, panels, {}, Alignment.Horizontal.Left, Alignment.Vertical.Bottom);
	}
}
